import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { ToDateTime } from '../utils/to-date-time';

export const endDateAfterStartDateValidator =
  (startDateControlName = 'startDate', message = 'End date must be on or after start date'): ValidatorFn =>
  (control: AbstractControl<Date | string | null>): ValidationErrors | null => {
    const startDate = ToDateTime(control.parent?.get(startDateControlName)?.value);
    const endDate = ToDateTime(control.value);

    if (startDate === null || endDate === null || endDate >= startDate) {
      return null;
    }

    return { isCustom: true, message };
  };
